import { http } from 'services';

export const All = () => http.request.get('/v1/gov-function/open-organization/categories');